import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/MasterData/SiteLocation/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { v3_add_site_location } from '../../../actions/v3/masterData'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_site_location(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listSiteLocationMasterData.url)
            }
            else {
                toast.error(res.error)
            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Add Site Location'}
            >
                <Form
                    title={'Add Site Location'}
                    onSubmit={onSubmit}
                    buttonName={'Create Site Location'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add